<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.6839 2.27026C12.2716 1.88219 11.6049 1.91205 11.2317 2.35982L6.23174 8.35982L6.1639 8.4506C5.73186 9.099 6.19066 10 6.99996 10H17L17.1131 9.994C17.8878 9.9108 18.2863 8.98154 17.7682 8.35982L12.7682 2.35982L12.6839 2.27026ZM17.836 15.5494C18.2681 14.901 17.8093 14 17 14H6.99996L6.88679 14.006C6.11209 14.0892 5.71364 15.0185 6.23174 15.6402L11.2317 21.6402L11.316 21.7297C11.7283 22.1178 12.395 22.088 12.7682 21.6402L17.7682 15.6402L17.836 15.5494Z"
    fill="currentColor"
  />
</svg>
